import { Box, Modal, IconButton, Tooltip, Link, Avatar, Divider } from '@mui/material'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { Button, Flex, Input, Text } from '@pancakeswap/uikit';
import bscscan from '../../../../assets/images/bscscan.png'
import drivenx from '../../../../assets/images/drivenx.png'
import bnb from '../../../../assets/images/bnb.png'
import AddIcon from '@mui/icons-material/Add';
import { getContract } from 'utils/contractHelpers';
import LPTokenABI from '../../../../ABI/LpTokenABI.json'
import ERC20ABI from '../../../../ABI/ERC20ABI.json'
import UniRouterABI from '../../../../ABI/UniRouterABI.json'
import addresses from "../../../../constants/contract";
import { useWeb3React } from '@web3-react/core';
import { ethers } from 'ethers';
import { injected } from "helper/connectors";
import { getRouterAddress, getTokenAddress } from 'utils/addressHelpers';

interface LiquidityModalProps {
    onClose: () => void;
    open: boolean;
    pool: any;

}
const ConnectButton = styled(Button)`
  -webkit-box-align: center;
  align-items: center;
  border: 0px;
  border-radius: 16px;
  box-shadow: rgb(14 14 44 / 40%) 0px -1px 0px 0px inset;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  -webkit-box-pack: center;
  justify-content: center;
  letter-spacing: 0.03em;
  line-height: 1;
  opacity: 1;
  outline: 0px;
  transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
  height: 48px;
  padding: 0px 24px;
  background-color: #00FED9;
  color: black;
  width: 100%;
`;
const ModalHeader = styled(Box)`
    align-items: center;
    background: #00202F;
    display: flex;
    padding: 24px 24px;
    /* border-radius-top-left: 32px; */
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;

`
const ModalHeaderText = styled(Box)`
    align-items: center;
    flex: 1 1 0%;
    display: flex;
    justify-content: space-between;
`
const Modalbodysemitext = styled(Box)`
    color:#ffffff;
    font-size:16px;
    font-weight:400;
    line-height:1.5;
`
const ScrollableContainer = styled.div`
  /* padding-bottom: 30px; */
  padding: 24px;
  height:500px;
  max-height: 90vh;
  overflow-y: auto;
`
const TextInput = styled(Box)`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    color: rgb(15, 33, 49);
    font-size: 0.75rem;
    line-height: 1rem;
    padding: 0.75rem 1rem 0px;
`

const StyledInput = styled(Input) <{ textAlign?: string }>`
  background: transparent;
  border-radius: 0;
  color : white;
  box-shadow: none;
  padding-left: 0;
  padding-right: 0;
  text-align: ${({ textAlign = "left" }) => textAlign};
  border: none;

  ::placeholder {
    color: #B1B3CB;
  }

  &:focus:not(:disabled) {
    box-shadow: none;
  }
`;

const BSCscanLink = styled(Link)`
    display: flex;
    align-items: center;
    width: fit-content;
    text-decoration: none;

`

const MaxButton = styled(Button)`
    align-items: center;
    border: 0px none;
    border-radius: 16px;
    cursor: pointer;
    display: inline-flex;
    font-family: inherit;
    font-size: 16px;
    font-weight: 600;
    -moz-box-pack: center;
    justify-content: center;
    letter-spacing: 0.03em;
    line-height: 1;
    opacity: 1;
    outline: currentcolor none 0px;
    transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
    height: 32px;
    padding: 0px 16px;
    background-color: transparent;
    /* color: rgb(15, 33, 49); */
    color: rgb(243, 244, 246);
    box-shadow: none;
`

const PlusIcon = styled(Box)`
    width: 100%;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
`

const PoolshareText = styled(Box)`
    flex-wrap: wrap;
    margin: -4px;
    justify-content: space-around;
    display: flex;
    padding: 0px;
    -moz-box-align: center;
    align-items: center;
`


const LiquidityModal: React.FC<LiquidityModalProps> = ({ open, onClose, pool }) => {
    const { error, activate, deactivate, library, active, account } = useWeb3React();

    const [input0, setInput0] = useState('');
    const [input1, setInput1] = useState('');
    const [tokenbalance, setTokenBalance] = useState(0);
    const [wbnbbalance, setWbnbBalance] = useState(0);
    const balancegetfortoken = getContract(ERC20ABI, pool.tokenAddr);
    useEffect(() => {
        let getBalance = async () => {
            if (active) {
                allowance();
                setTokenBalance(await balancegetfortoken.balanceOf(account));
                setWbnbBalance(await library.getBalance(account));
            }
        }
        getBalance();
    }, [account])
    const tokenpair = getContract(LPTokenABI, pool.lpToken);
    const tokenrouter = getContract(UniRouterABI, getRouterAddress());

    const getLiquidityAmount = async (amount, token) => {
        const pairreserve = await tokenpair.getReserves();
        let routeramount;
        if (token == 0) {
            amount = ethers.utils.parseUnits(amount.toString(), pool.tokenDecimal);
            routeramount = await tokenrouter.quote(amount, pairreserve[0], pairreserve[1]);
            routeramount = ethers.utils.formatEther(routeramount);
        } else {
            amount = ethers.utils.parseEther(amount.toString());
            routeramount = await tokenrouter.quote(amount, pairreserve[1], pairreserve[0]);
            routeramount = ethers.utils.formatUnits(routeramount);
        }
        return routeramount;
    }

    const [stakeEnable, setstackeEnable] = useState("Approve");
    const [loading, setLoading] = useState(false);

    const MAX_INT = "115792089237316195423570985008687907853269984665640564039457584007913129639935";
    const allowance = async () => {
        setLoading(true);
        try {
            const contract = getContract(ERC20ABI, pool.tokenAddr, library.getSigner());
            const allowance1 = await contract.allowance(account, getRouterAddress());
            // console.log(allowance1);
            // const flag = allowance1.toString() === MAX_INT;
            const flag = allowance1.toString() !== "0";
            // console.log(allowance1.toString());
            // debugger;
            setstackeEnable(flag ? "Supply" : "Approve");
            setLoading(false);
            return flag;
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
        return false;
    }

    const enable = async () => {
        if (!active) {
            return;
        }
        if (stakeEnable === "Approve") {
            if (await allowance()) {
                return;
            };
        }
        setLoading(true);
        try {
            const contract = getContract(ERC20ABI, pool.tokenAddr, library.getSigner());
            const tx = await contract.approve(getRouterAddress(), MAX_INT);
            await tx.wait();
            setstackeEnable("Supply");
        }
        catch (err) {
            console.log(err);
        }
        setLoading(false);

    };

    const input0Change = async (e) => {
        setInput0(e.target.value)
        if (parseFloat(e.target.value) > 0) {
            let output = await getLiquidityAmount(parseFloat(e.target.value), 1);
            setInput1(output.toString());
        } else {
            setInput1('');
        }
    }

    const input1Change = async (e) => {
        setInput1(e.target.value)
        if (parseFloat(e.target.value) > 0) {
            let output = await getLiquidityAmount(parseFloat(e.target.value), 0);
            setInput0(output.toString());
        } else {
            setInput0('');
        }
    }

    const inputMaxChange = async (value, number) => {
        if (parseFloat(value) > 0) {
            let output = await getLiquidityAmount(parseFloat(value), number);
            number == 1 ? setInput0(output.toString()) : setInput1(output.toString());
        }
    }
    // useEffect(() => {
    //     getLiquidityAmount();
    // }, [])
    const addLiquidity = async () => {
        if (stakeEnable != "Supply") {
            enable();
            return;
        }
        if (parseFloat(input0) > 0 && parseFloat(input1) > 0) {
            setLoading(true);
            try {
                const tokenrouter = getContract(UniRouterABI, getRouterAddress(), library.getSigner());
                const tx = await tokenrouter.addLiquidityETH(
                    getTokenAddress(),
                    ethers.utils.parseUnits(input1, pool.tokenDecimal),
                    "0",
                    "0",
                    account,
                    Math.ceil(((new Date()).getTime()) / 1000) + 60 * 5
                    , { value: ethers.utils.parseEther(input0) });
                onClose();
                await tx.wait();
            } catch (err) {
                console.log(err)
            }
            setLoading(false);
        }
    }


    async function connect(walletType) {
        // console.log(active);
        setLoading(true);
        try {
            await deactivate();
            if (walletType === "metamask") {
                console.log("Connecting Metamsk");
                await activate(injected);
            }
        } catch (ex) {
            console.log(ex);
        }
        setLoading(false);
    }
    return (
        <>
            <Modal
                open={open}
                onClose={onClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                }}>
                    <Box sx={{
                        // width: '470px',
                        background: '#1A3342',
                        borderRadius: '32px',
                        zIndex: '100',
                        // minWidth: '330px',
                        minWidth: { xs: '300px', sm: '330px', md: '400px', lg: '470px' },
                        maxHeight: '100vh',
                        overflow: 'hidden',
                    }}>
                        <ModalHeader id="modal-modal-title" >
                            <ModalHeaderText>
                                <Box
                                    sx={{
                                        fontSize: '20px',
                                        fontWeight: '600',
                                        lineHeight: '1.1',
                                        display: 'flex',
                                        gap: '10px',
                                        color: 'white',
                                    }}>
                                    Add Liquidity
                                </Box>
                                <CloseOutlinedIcon sx={{ color: "white", width: "20px", height: "20px" }} onClick={onClose} style={{ cursor: 'pointer' }} />
                            </ModalHeaderText>
                        </ModalHeader>
                        <ScrollableContainer>
                            <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                <Modalbodysemitext>Add Liquidity to receive LP tokens</Modalbodysemitext>
                                <Box sx={{}}>
                                    <Tooltip title="There is a 1.00% fee to use this tool,the fee is used to buy back DVX token" sx={{ fontSize: '18px' }} arrow placement="top">
                                        <IconButton>
                                            <HelpOutlineOutlinedIcon sx={{ color: 'white', width: '22px', height: '22px' }} />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Box>
                            <Box sx={{ display: 'grid', gridAutoRows: 'auto', rowGap: '10px' }}>
                                <Box sx={{ display: 'flex', flexFlow: 'column nowrap', position: 'relative', borderRadius: '20px', backgroundColor: 'rgb(250, 249, 250)', zIndex: '1' }}>
                                    <Box sx={{ borderRadius: '16px', backgroundColor: '#1A3342', border: '1px solid #00FED9', boxShadow: 'rgba(74, 74, 104, 0.1) 0px 2px 2px -1px inset' }}>
                                        <TextInput>
                                            <Box sx={{ justifyContent: 'space-between', width: '100%', display: 'flex', p: 0, alignItems: 'center' }} >
                                                <Text color='rgb(243, 244, 246)' fontWeight={400} lineHeight={1.5} fontSize='14px'>
                                                    Input
                                                </Text>
                                                <Text style={{ display: 'flex', cursor: 'pointer' }} color='rgb(243, 244, 246)' fontWeight={400} lineHeight={1.5} fontSize='14px'>
                                                    Balance: &nbsp; 
                                                    <Text fontWeight='bold' color='rgb(243, 244, 246)'> {parseFloat((ethers.utils.formatUnits(tokenbalance.toString(), pool.token1Decimal)).toString()).toFixed(4)} </Text>&nbsp;
                                                    <Text style={{}} color='rgb(243, 244, 246)' fontWeight={400} lineHeight={1.5} fontSize='14px'>
                                                        ($0.00)
                                                    </Text>
                                                </Text>
                                            </Box>
                                        </TextInput>
                                        <Box sx={{ display: 'flex', flexFlow: 'row nowrap', alignItems: 'center', padding: '0.75rem 0.5rem 0.75rem 1rem' }}>
                                            <Box sx={{ display: 'flex', flex: '1 1 auto', flexDirection: 'column' }}>
                                                <StyledInput
                                                    pattern={`^[0-9]*[.,]?[0-9]{0,${'18'}}$`}
                                                    inputMode="decimal"
                                                    min={0}
                                                    placeholder={'0.0'}
                                                    value={input1}
                                                    onChange={(e) => input1Change(e)}
                                                />

                                                <BSCscanLink>
                                                    <Flex alignItems='center'>
                                                        <img width={15} height='auto' src={bscscan} />{' '}
                                                        <Text color='rgb(243, 244, 246)' fontWeight={400} fontSize='11px' lineHeight={1}>
                                                            0x6aAc...C3e7
                                                        </Text>
                                                    </Flex>
                                                </BSCscanLink>

                                            </Box>
                                            {active && parseFloat(input1) < parseFloat((ethers.utils.formatUnits(tokenbalance.toString(), pool.token1Decimal)).toString()) && <MaxButton scale='sm' onClick={() => { setInput1((ethers.utils.formatUnits(tokenbalance.toString(), pool.token1Decimal)).toString()); inputMaxChange((ethers.utils.formatUnits(tokenbalance.toString(), pool.token1Decimal)).toString(), 1) }} sx={{ color: 'rgb(243, 244, 246)' }}>Max</MaxButton>}
                                            <MaxButton>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <img width={24} height={24} style={{ marginRight: '8px' }} src={drivenx} />
                                                    <Text color='rgb(243, 244, 246)' fontWeight={400} fontSize='16px' lineHeight={1.5}>{pool.tokenSymbol}</Text>
                                                </Box>
                                            </MaxButton>
                                        </Box>
                                    </Box>
                                </Box>
                                <PlusIcon>
                                    <AddIcon sx={{ color: 'white' }} />
                                </PlusIcon>
                                <Box sx={{ display: 'flex', flexFlow: 'column nowrap', position: 'relative', borderRadius: '20px', backgroundColor: 'rgb(250, 249, 250)', zIndex: '1' }}>
                                    <Box sx={{ borderRadius: '16px', backgroundColor: '#1A3342', border: '1px solid #00FED9', boxShadow: 'rgba(74, 74, 104, 0.1) 0px 2px 2px -1px inset' }}>
                                        <TextInput>
                                            <Box sx={{ justifyContent: 'space-between', width: '100%', display: 'flex', p: 0, alignItems: 'center' }}>
                                                <Text color='rgb(243, 244, 246)' fontWeight={400} lineHeight={1.5} fontSize='14px'>
                                                    Input
                                                </Text>
                                                <Text style={{ display: 'flex', cursor: 'pointer' }} color='rgb(243, 244, 246)' fontWeight={400} lineHeight={1.5} fontSize='14px'>
                                                    Balance: &nbsp;
                                                    <Text fontWeight='bold' color='rgb(243, 244, 246)'>{parseFloat((ethers.utils.formatUnits(wbnbbalance.toString(), 18)).toString()).toFixed(4)} </Text>&nbsp;
                                                    <Text color='rgb(243, 244, 246)' fontWeight={400} lineHeight={1.5} fontSize='14px'>
                                                        ($0.00)
                                                    </Text>
                                                </Text>
                                            </Box>
                                        </TextInput>
                                        <Box sx={{ display: 'flex', flexFlow: 'row nowrap', alignItems: 'center', padding: '0.75rem 0.5rem 0.75rem 1rem' }}>
                                            <Box sx={{ display: 'flex', flex: '1 1 auto', flexDirection: 'column' }}>
                                                <StyledInput
                                                    pattern={`^[0-9]*[.,]?[0-9]{0,${'18'}}$`}
                                                    inputMode="decimal"
                                                    min={0}
                                                    placeholder={'0.0'}
                                                    value={input0}
                                                    onChange={(e) => input0Change(e)}
                                                />
                                            </Box>
                                            {active && parseFloat(input0) < parseFloat((ethers.utils.formatUnits(wbnbbalance.toString(), pool.token0Decimal)).toString()) && <MaxButton scale='sm' onClick={() => { setInput0((ethers.utils.formatUnits(wbnbbalance.toString(), pool.token0Decimal)).toString()); inputMaxChange((ethers.utils.formatUnits(wbnbbalance.toString(), pool.token0Decimal)).toString(), 0) }} sx={{ color: 'rgb(243, 244, 246)' }}>Max</MaxButton>}
                                            <MaxButton>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <img width={24} height={24} style={{ marginRight: '8px' }} src={bnb} />
                                                    <Text color='rgb(243, 244, 246)' fontWeight={400} fontSize='16px' lineHeight={1.5}>{`WBNB`}</Text>
                                                </Box>
                                            </MaxButton>
                                        </Box>
                                    </Box>
                                </Box>

                                <Box sx={{ border: '2px solid #00FED9', backgroundColor: '#1A3342', width: '100%', p: 0, borderRadius: '20px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', p: 2, justifyContent: 'space-between' }}>
                                        <Text color='rgb(243, 244, 246)' fontWeight={400} fontSize='16px' lineHeight={1.5}>
                                            Prices and pool share
                                        </Text>
                                    </Box>
                                    {/* <Divider /> */}
                                    <Box sx={{ backgroundColor: '#1A3342', p: 2, borderRadius: '20px' }}>
                                        <Box sx={{ display: 'grid', gridAutoRows: 'auto', rowGap: '12px' }}>
                                            <PoolshareText>
                                                <Box sx={{ m: 0.5, display: 'grid', gridAutoRows: 'auto', justifyItems: 'center' }}>
                                                    <Text color='rgb(243, 244, 246)' fontWeight={400} fontSize='16px' lineHeight={1.5}>
                                                        0.0000496912
                                                    </Text>
                                                    <Text color='rgb(243, 244, 246)' fontWeight={400} fontSize='16px' lineHeight={1.5}>
                                                        {pool.token0Symbol} per {pool.token1Symbol}
                                                    </Text>
                                                </Box>
                                                <Box sx={{ m: 0.5, display: 'grid', gridAutoRows: 'auto', justifyItems: 'center' }}>
                                                    <Text color='rgb(243, 244, 246)' fontWeight={400} fontSize='16px' lineHeight={1.5}>
                                                        20155.2
                                                    </Text>
                                                    <Text color='rgb(243, 244, 246)' fontWeight={400} fontSize='16px' lineHeight={1.5}>
                                                        {pool.token1Symbol} per {pool.token0Symbol}
                                                    </Text>
                                                </Box>
                                                <Box sx={{ m: 0.5, display: 'grid', gridAutoRows: 'auto', justifyItems: 'center' }}>
                                                    <Text color='rgb(243, 244, 246)' fontWeight={400} fontSize='16px' lineHeight={1.5}>
                                                        1%
                                                    </Text>
                                                    <Text color='rgb(243, 244, 246)' fontWeight={400} fontSize='16px' lineHeight={1.5}>
                                                        Share pool
                                                    </Text>
                                                </Box>

                                            </PoolshareText>

                                        </Box>
                                    </Box>
                                </Box>

                                <Box>
                                    {!active ?
                                        <ConnectButton onClick={() => connect("metamask")} disabled={loading}>
                                            Connect Wallet
                                        </ConnectButton>
                                        :
                                        <Button variant="secondary" size="lg" width='100%' onClick={addLiquidity} disabled={loading} >
                                            {stakeEnable}
                                        </Button>}
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', mb: 5 }}>
                                    <Box sx={{ color: '#ffffff', fontSize: '14px', fontWeight: '400' }}>
                                        By adding liquidity you'll earn 0.17% of all trades on this <br />
                                        pair proportional to your shareof the pool.Fees are <br />
                                        added to the pool,accrue in real time and can be claimed <br />
                                        by withdrawing your liquidity.
                                    </Box>
                                </Box>
                            </Box>
                        </ScrollableContainer>
                    </Box>
                </Box >
            </Modal >
        </>
    )
}
export default LiquidityModal